import React from "react";
import { Button } from "@/components/ui/button";
import { CONTACT_PHONE_DISPLAY, CONTACT_PHONE_TEL } from "@/constants/delivery";

const Section = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="font-serif text-xl font-semibold text-foreground">{title}</h2>
    <div className="mt-2 space-y-3 text-sm leading-relaxed text-muted-foreground font-ui">
      {children}
    </div>
  </section>
);

export default function PrivacyPolicyPage() {
  const openCookieSettings = () => {
    window.dispatchEvent(new CustomEvent("open-cookie-settings"));
  };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
      <h1 className="font-serif text-2xl md:text-3xl font-semibold text-foreground">
        Politika privatnosti i kolačića
      </h1>
      <p className="mt-2 text-sm text-muted-foreground font-ui">
        Poslednje ažuriranje: jun 2026.
      </p>

      <Section title="Ko smo">
        <p>
          Sjenički Proizvodi Fazlić, Izeta Čavića, Prijepolje. Za sva pitanja u
          vezi sa zaštitom podataka možete nas kontaktirati na{" "}
          <a href={CONTACT_PHONE_TEL} className="text-primary underline underline-offset-2">
            {CONTACT_PHONE_DISPLAY}
          </a>
          .
        </p>
      </Section>

      <Section title="Koje podatke prikupljamo">
        <p>
          Prilikom narudžbine prikupljamo podatke koje sami unesete (ime, adresa,
          broj telefona) isključivo radi obrade i isporuke porudžbine.
        </p>
        <p>
          Uz vaš pristanak koristimo i kolačiće za analitiku i oglašavanje koji
          mogu prikupljati podatke o korišćenju sajta.
        </p>
      </Section>

      <Section title="Kolačići koje koristimo">
        <p>
          <strong className="text-foreground">Neophodni kolačići</strong> — potrebni
          za osnovni rad sajta i funkciju korpe. Ne zahtijevaju pristanak.
        </p>
        <p>
          <strong className="text-foreground">Analitički kolačići (PostHog)</strong> —
          pomažu nam da razumijemo kako se sajt koristi. Aktiviraju se samo uz vaš
          pristanak.
        </p>
        <p>
          <strong className="text-foreground">Marketinški kolačići (Google Ads)</strong> —
          koriste se za mjerenje konverzija i oglašavanje. Aktiviraju se samo uz vaš
          pristanak. Više: {" "}
          <a
            href="https://policies.google.com/privacy"
            target="_blank"
            rel="noreferrer"
            className="text-primary underline underline-offset-2"
          >
            Google politika privatnosti
          </a>
          .
        </p>
      </Section>

      <Section title="Vaša prava">
        <p>
          U svakom trenutku možete povući ili promijeniti svoj pristanak na
          kolačiće, kao i tražiti uvid, ispravku ili brisanje svojih podataka.
        </p>
        <Button variant="outline" onClick={openCookieSettings} className="mt-2">
          Podešavanja kolačića
        </Button>
      </Section>
    </div>
  );
}
